import React from 'react';

import { Star, Trash2Icon } from 'lucide-react';

import { FilledStar, FormField, FormInput, SubForm } from '@/_components';

import type { Props } from './use-update-email-item';
import { useUpdateEmailItem } from './use-update-email-item';

import { ActionButton } from '../../../actions';
import { ActionButtonContainer } from '../../../layout';

function UpdateEmailItemBase(props: Props) {
  const { id, pivot, form, onSubmit, handleOnChange, isPending } = useUpdateEmailItem(props);

  return (
    <SubForm id={`update-email-${id}`} {...form} onSubmit={onSubmit} isSubmitting={isPending}>
      <article className="col-span-12 flex flex-nowrap items-start justify-between">
        <div className="flex-1">
          <FormField
            control={form.control}
            name="email"
            render={({ field: { value } }) => (
              <FormInput
                label="Email"
                name="email"
                type="email"
                value={value}
                onChange={handleOnChange}
                labelProps={{ className: 'w-[calc(100%_+_3.5rem)]' }}
                messageProps={{ className: 'hidden' }}
              />
            )}
          />
        </div>
        <section className="flex items-center">
          <FormField
            control={form.control}
            name="pivot.default"
            render={({ field: { onChange } }) => (
              <ActionButtonContainer>
                <ActionButton
                  title="Set Default"
                  className={(pivot?.default ?? 0) ? 'opacity-100 hover:opacity-100' : 'opacity-40'}
                  icon={(pivot?.default ?? 0) ? FilledStar : Star}
                  onClick={() => {
                    onChange(1);
                  }}
                />
              </ActionButtonContainer>
            )}
          />
          <FormField
            control={form.control}
            name="intent"
            render={({ field: { onChange } }) => (
              <ActionButtonContainer>
                <ActionButton
                  title="Delete"
                  icon={Trash2Icon}
                  onClick={() => {
                    onChange('delete');
                  }}
                />
              </ActionButtonContainer>
            )}
          />
        </section>
      </article>
    </SubForm>
  );
}

export const UpdateEmailItem = React.memo(UpdateEmailItemBase);
